import CodeMirror from "@uiw/react-codemirror";
import { json } from "@codemirror/lang-json";

export function JsonEditor({
  value,
  onChange,
  height = "260px",
  readOnly = false,
}: {
  value: string;
  onChange: (next: string) => void;
  height?: string;
  readOnly?: boolean;
}) {
  return (
    <div className="rounded-md border border-border overflow-hidden">
      <CodeMirror
        value={value}
        height={height}
        theme="dark"
        extensions={[json()]}
        readOnly={readOnly}
        onChange={onChange}
        basicSetup={{
          lineNumbers: true,
          highlightActiveLine: false,
          foldGutter: true,
          tabSize: 2,
        }}
      />
    </div>
  );
}
